interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({ title = 'Something went wrong', message, onRetry }: ErrorStateProps) {
  return (
    <div
      className="surface surface-padding"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem',
        borderLeft: '4px solid var(--color-danger)'
      }}
    >
      <div style={{ fontWeight: 600 }}>{title}</div>
      {message && <div className="text-muted">{message}</div>}
      {onRetry && (
        <div>
          <button
            type="button"
            onClick={onRetry}
            style={{
              background: 'var(--color-primary)',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              padding: '0.5rem 1rem',
              cursor: 'pointer'
            }}
          >
            Retry
          </button>
        </div>
      )}
    </div>
  );
}

